import React, { useState } from 'react';
import HeaderMain from "../components/header/HeaderMain";
import NavMain from "../components/nav/NavMain";
import AutosuggestComponent from "../document/AutosuggestComponent";
import DocumentPersonalConsentAndDeclarationOfBeneficiaryForMortuaryFundContributionProgram from '../document/DocumentPersonalConsentAndDeclarationOfBeneficiaryForMortuaryFundContributionProgram';


function PersonalConsentAndDeclarationOfBeneficiaryForMortuaryFundContributionProgram() {
    const [applicantDetails, setApplicantDetails] = useState(null);
    const [loanProcessingDetails, setLoanProcessingDetails] = useState([]);

    return (
        <>
            <NavMain slug="personal-consent-and-declaration-of-beneficiary-for-mortuary-fund-contribution-program" parent="5" />
            <HeaderMain slug="personal-consent-and-declaration-of-beneficiary-for-mortuary-fund-contribution-program" />
            <div className="main-content documents">
                <AutosuggestComponent
                setApplicantDetails={setApplicantDetails}
                setLoanProcessingDetails={setLoanProcessingDetails}
                />
                <DocumentPersonalConsentAndDeclarationOfBeneficiaryForMortuaryFundContributionProgram
                    applicantDetails={applicantDetails}
                    loanProcessingDetails={loanProcessingDetails}
                />
            </div>
        </>
    );
}

export default PersonalConsentAndDeclarationOfBeneficiaryForMortuaryFundContributionProgram;